<div class="esf-main-layout esf-main-layout--has-sidebar">
  <aside class="esf-main-sidebar esf-main-sidebar--primary" style="overflow: auto;">
    <div class="esf-authentication">
      <div class="esf-authentication__logo">
        <img src="./assets/images/eventimtixx-logo.svg" width="180" alt="logo">
      </div>
      <div class="esf-authentication__login">
        <h1 i18n='Heading title for the login page@@loginComponent.pageTitle.heading.tixxCrmLogin'>Tixx-CRM Login</h1>
        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">

          <div app-form-field-text-generic
               class="esf-form-item--1-2"
               [control]="loginForm.controls['username']"
               [label]="flTranslations.i18nUsername">
          </div>

          <div app-form-field-password
               class="esf-form-item--1-2"
               [label]="flTranslations.i18nPassword"
               [control]="loginForm.controls['password']">
          </div>

          <div class="esf-form-item">
            <button i18n='An action button that executes login to the application@@button.login' *ngIf="!loading" [disabled]="loading"
                    class="esf-button esf-button--standard esf-button--filled" style="width: 100%">Login</button>
            <app-spinner [(show)]="loading"></app-spinner>
          </div>
        </form>
      </div>
      <div class="esf-authentication__register">
        <app-footer></app-footer>
      </div>
    </div>
  </aside>
  <main class="esf-main-content esf-main-content--has-sidebar">
    <div class="esf-authentication__visual" [style.background-image]="image"></div>
  </main>

  <app-password-reset [passwordResetModal]="passwordResetModal" (completed)="afterCompleted($event)"></app-password-reset>

</div>
